<!--97 px is heigth navbar-->
<ng-container *ngIf="showSidenav">
    <app-navbar class="visualized-in-Mobile"
                [isTest]="isTest"
                [currentUrl]="currentUrl"
                [disabledMenu]="disabledMenu"
                [links]="links|filterByPredicateFunction:filterLinkPredicate:(projectPermissions$|async)"
                [toRead]="(notificationsNotReadedInProject$|async)"
    ></app-navbar>
    <mat-card class="sidenav-border visualized-in-desktop"
              [ngClass]="{'background-test':isTest}"
              (mouseover)="openSidenav()"
              (mouseleave)="closeSidenav()"
    >
        <mat-card-content class="h100">
            <div class="flex-between-center flex-direction-column h100">
                <div style="margin-bottom: 10px">
                    <img [src]="getUrlLogo()"
                         [ngClass]="classHunaLogo">
                    <div class="fake-icon-background-text name-project" *ngIf="nameProject">{{ nameProject }}
                    </div>
                </div>
                <div class="flex-start-start flex-direction-row" [ngClass]="{'width-text':selectGroup$|async}">
                    <div [ngStyle]="borderStyleGroup$|async"
                    >
                        @if (!disabledMenu) {
                            @for (group of links|filterByPredicateFunction:getGroupsLinkPredicate:(projectPermissions$|async); track group) {
                                <div class="flex-start-center w100  background-color-primary-transparent-hoover"
                                     (mouseover)="setSelectGroup(group)"
                                     (click)="goTo(group.path)"
                                     style="cursor: pointer;border-radius: 3px"
                                     mat-ripple>
                                    <a mat-icon-button
                                       [ngClass]="{'background-default-select':group|transformValueByPredicateFunction:groupContainEqualLinkPredicate:currentLink}">
                                        <ng-container *ngIf="group.iconCustom;else icon">
                                            <mat-icon>
                                                <img src="{{group.iconCustom}}" style=";max-width: 24px;"
                                                     class="invert-color-dark-theme">
                                            </mat-icon>
                                        </ng-container>
                                        <ng-template #icon>
                                            <mat-icon
                                                    [color]="group|transformValueByPredicateFunction:getColorIconNotificationsPredicate:(notificationsNotReadedInProject$|async)"
                                                    *ngIf="group.icon"
                                            >{{ group.icon }}
                                            </mat-icon>
                                        </ng-template>
                                    </a>
                                    @if (selectGroup$|async; as selectGroup) {
                                        @if (selectGroup.path == group.path) {
                                            <div style="padding-right: 10px;">{{ group.title | translate }}</div>
                                        }
                                    }
                                    <!--                                    <div [ngClass]="classTitleLink">{{ link.title | translate }}</div>-->
                                </div>
                            }
                        }
                    </div>
                    <div [ngClass]="classTitleLink">
                        @if ((selectGroup$|async); as selectGroup) {
                            @for (link of selectGroup.links; track link) {
                                <div class="flex-start-center w100 background-color-primary-transparent-hoover"
                                     routerLink="{{link.path}}"
                                     [ngClass]="{'background-default-select':link|transformValueByPredicateFunction:isEqualLinkPredicate:currentLink}"
                                     style="cursor: pointer;border-radius: 3px" mat-ripple>
                                    <a mat-icon-button
                                    >
                                        <ng-container *ngIf="link.iconCustom;else icon">
                                            <mat-icon>
                                                <img src="{{link.iconCustom}}" style=";max-width: 24px;"
                                                     class="invert-color-dark-theme">
                                            </mat-icon>
                                        </ng-container>
                                        <ng-template #icon>
                                            <mat-icon
                                                    [color]="link|transformValueByPredicateFunction:getColorIconNotificationsPredicate:(notificationsNotReadedInProject$|async)"
                                                    *ngIf="link.icon"

                                            >{{ link.icon }}
                                            </mat-icon>
                                        </ng-template>
                                    </a>
                                    <div [ngClass]="classTitleLink"
                                         style="padding-right: 10px;max-width: 170px;" class="truncate">{{ link.title | translate }}
                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
                <div class=" flex-center-start flex-direction-column">
                    <app-setting-option-button [currentUrl]="currentUrl" flow="column"
                                               [classTitleLink]="classTitleLink"
                                               [isSystemAdmin]="isSystemAdmin$|async"
                    >

                    </app-setting-option-button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>

<mat-card class="my-mat-card " [ngClass]="{'padding-container-app':showSidenav}">
    <ng-content>

    </ng-content>
</mat-card>

